export default {
  access_token: "",
  refresh_token: "",
  currentUser: {},
  role: "",
  isLoading: false
};
